<template>
  <div
    class="input"
    :class="props.kind ? props.kind : ''"
    :kind="kind"
    :mask="props.mask"
    ref="wrapper"
  >
    <input
      :id="props.id"
      :type="props.type"
      :name="props.name"
      :class="props.class"
      :title="props.label"
      :autocomplete="props.autocomplete"
      :autofocus="props.autofocus"
      :value="props.value"
      :data-value="props.value"
      :readonly="props.readonly && props.readonly"
      :disabled="props.disabled && props.disabled"
      :required="props.required && props.required"
      @focus.prevent="$event.target.select()"
      @input="handleInput($event)"
      ref="input"
    />

    <label :for="props.id">
      {{ props.label }}
      <span
        v-if="props.required"
        class="text-[red] font-bold"
        >*</span
      >
    </label>

    <button
      class="show-password"
      type="button"
      v-if="props.type === 'password'"
      @click="toggleInputType"
      ref="showPasswordButton"
      title="Mostrar senha"
    >
      <v-icon iconify="ri:eye-line"></v-icon>
    </button>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as VMasker from 'vanilla-masker';

  const input = ref(null);
  const showPasswordButton = ref(null);
  const wrapper = ref(null);

  const props = defineProps({
    name: {
      default: '',
      type: String,
    },

    label: {
      default: '',
      type: String,
    },

    id: {
      type: String,
    },

    class: {
      type: String,
    },

    autocomplete: {
      default: 'autocomplete',
      type: String,
    },

    type: {
      default: 'text',
      type: String,
    },

    kind: {
      default: 'default',
      type: String,
    },

    mask: {
      default: '',
      type: String,
    },

    maskMoney: {
      type: Boolean,
    },

    readonly: {
      type: String,
    },

    disabled: {
      type: String,
    },

    autofocus: {
      default: false,
      type: Boolean,
    },

    value: {
      type: String,
    },

    uppercase: {
      default: false,
      type: Boolean,
    },

    required: {
      default: false,
      type: Boolean,
    },
  });

  function handleInput(event) {
    event.target.value = props.uppercase
      ? event.target.value.toUpperCase()
      : event.target.value;

    event.target.setAttribute('data-value', event.target.value);
  }

  function toggleInputType() {
    if (input.value.type == 'text') {
      input.value.type = 'password';

      showPasswordButton.value.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="currentColor" d="M12 3c5.392 0 9.878 3.88 10.819 9c-.94 5.12-5.427 9-10.819 9c-5.392 0-9.878-3.88-10.819-9C2.121 6.88 6.608 3 12 3zm0 16a9.005 9.005 0 0 0 8.777-7a9.005 9.005 0 0 0-17.554 0A9.005 9.005 0 0 0 12 19zm0-2.5a4.5 4.5 0 1 1 0-9a4.5 4.5 0 0 1 0 9zm0-2a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5z"/></svg>';
      showPasswordButton.value.title = 'Mostrar senha';
    } else {
      input.value.type = 'text';

      showPasswordButton.value.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="currentColor" d="M17.882 19.297A10.949 10.949 0 0 1 12 21c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 0 1 3.34-6.066L1.392 2.808l1.415-1.415l19.799 19.8l-1.415 1.414l-3.31-3.31zM5.935 7.35A8.965 8.965 0 0 0 3.223 12a9.005 9.005 0 0 0 13.201 5.838l-2.028-2.028A4.5 4.5 0 0 1 8.19 9.604L5.935 7.35zm6.979 6.978l-3.242-3.242a2.5 2.5 0 0 0 3.241 3.241zm7.893 2.264l-1.431-1.43A8.935 8.935 0 0 0 20.777 12A9.005 9.005 0 0 0 9.552 5.338L7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.592zm-9.084-9.084a4.5 4.5 0 0 1 4.769 4.769l-4.77-4.769z"/></svg>';
      showPasswordButton.value.title = 'Esconder senha';
    }
  }

  onMounted(() => {
    const $el = input.value;
    const $wrapper = wrapper.value;

    const rand = Math.floor(Math.random() * 1000);

    $el.id = props.id ? props.id : 'generic-id-' + rand;
    $wrapper
      .querySelector('label')
      .setAttribute('for', props.id ? props.id : 'generic-id-' + rand);

    /**
     * Máscaras de input
     */
    const masks = {
      cpf: '999.999.999-99',
      cnpj: '99.999.999/9999-99',
      phone: '(99) 99999-9999',
      date: '99/99/9999',
    };

    if (props.mask) {
      VMasker($el).maskPattern(masks[props.mask]);
    }

    if (props.type === 'password') {
      $wrapper.classList.add('input-password');
    } else if (props.type === 'date') {
      $el.classList.add('active');
    }

    $el.addEventListener('input', e => {
      addActiveClass();

      if (props.maskMoney) {
        VMasker($el).maskMoney();
      }
    });

    $el.addEventListener('change', () => {
      addActiveClass();
    });

    addActiveClass();

    function addActiveClass() {
      if ($el.value !== '') {
        $el.classList.add('active');
      } else {
        $el.classList.remove('active');
      }
    }
  });
</script>

<style scoped lang="scss">
  @import '@sass/global/functions';

  .input {
    position: relative;
    width: 100%;
    display: inline-block;
    margin-right: 8px;

    &.default {
      input {
        @apply bg-white
          pt-6
          px-2
          pb-2
          disabled:bg-black/10
          read-only:bg-black/10
          read-only:pointer-events-none
          border
          border-[#d1d1d1]
          focus-visible:border-[#969696]
          rounded
          outline-none
          w-full
          transition;

        &:focus,
        &.active {
          & + label {
            color: color(--primary);
            top: 2px;
            left: 8px;
            transform: scale(0.8);
            max-width: 100%;
          }
        }
      }

      label {
        color: #767676;
      }
    }

    &.large {
      input {
        @apply bg-white
          px-4
          pt-7
          pb-2
          border
          border-[#d1d1d1]
          focus-visible:border-[#969696]
          rounded
          w-full
          transition;

        outline: none;

        & + label {
          @apply left-4 top-3;
        }

        &:focus,
        &.active {
          & + label {
            @apply top-2;

            color: color(--primary);
            transform: scale(0.8);
            max-width: 100%;
          }
        }
      }

      label {
        color: #767676;
      }
    }

    &.input-password {
      position: relative;

      .show-password {
        @apply text-2xl text-gray-500;

        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        aspect-ratio: 1;
        cursor: pointer;
      }
    }
  }

  label {
    position: absolute;
    top: 0.6rem;
    left: 8px;
    color: #767676;
    transform-origin: top left;
    transition: 0.2s ease-in-out;
    pointer-events: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    max-width: calc(100% - 16px);
  }
</style>
